import React, { useEffect, useState } from "react";
import { Button, Card, Modal, ModalBody } from "reactstrap";
import styles from "./FeedbackModal.module.scss";
import Text from "components/Text";
import CustomRating from "components/CustomRating";
import crossImg from "../../assets/images/cross-mark-button.svg";
import Input from "components/Input";
import { rateAiMessage } from "repositories/ai-assistant-repository";
import { handleError, handleSuccess } from "utils";
import Loader from "components/Loader";

const CustomFeedbackModal = ({
  t,
  setModalOpen,
  modalOpen,
  selectedResponse,
  aiChatMessageId,
  onRatingSuccess,
}) => {
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);
  const [ratingError, setRatingError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const latestResponse =
    Array.isArray(selectedResponse?.ratings) &&
    selectedResponse?.ratings.length > 0
      ? selectedResponse?.ratings[0]
      : null;
  const locked =
    Array.isArray(selectedResponse?.ratings) &&
    selectedResponse?.ratings.length > 0;
  const handleChange = (e) => {
    setComment(e.target.value);
  };

  useEffect(() => {
    if (latestResponse) {
      setRating(latestResponse?.rating || 0);
      setComment(latestResponse?.commentByUser || "");
    }
  }, [selectedResponse?.ratings]);

  const giveRatingToAiResponse = async (nextRating, nextComment = comment) => {
    try {
      setIsSubmitting(true);
      const params = {
        AiChatMessageId:
          selectedResponse?.messageId ||
          aiChatMessageId ||
          selectedResponse?.id,
        Rating: nextRating,
        CommentByUser: nextComment || "",
      };
      const result = await rateAiMessage(params);
      handleSuccess(result?.message);

      if (typeof onRatingSuccess === "function") {
        onRatingSuccess({
          rating: nextRating,
          comment: nextComment,
        });
      }

      setModalOpen(false);
    } catch (error) {
      handleError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClick = async () => {
    if (!rating || rating <= 0) {
      setRatingError(t("aiAssistant.ratingRequired"));
      return;
    }
    setRatingError("");
    giveRatingToAiResponse(rating, comment);
  };

  return (
    <Modal
      toggle={() => setModalOpen(!modalOpen)}
      isOpen={modalOpen}
      centered={true}
      className={`modal-dialog-centered modal-width-660  ${styles["chat-feedback-rating-pop-up"]}`}
      modalClassName="custom-modal"
    >
      {isSubmitting && <Loader />}
      <Button
        className={styles["PatientAppointmentDetails-cross-btn"]}
        aria-label="Close"
        type="button"
        onClick={() => setModalOpen(!modalOpen)}
      >
        <img src={crossImg} alt="cross button" />
      </Button>
      <Text size="25px" weight="500" color="#111B45" marginBottom="30px">
        {" "}
        {t("aiAssistant.feedbackModal.title")}
      </Text>
      <ModalBody>
        <div className="mb-4">
          <Text size="12px" weight="400" color="#6F7788" marginTop="0px">
            {t("aiAssistant.feedbackModal.rating")}
          </Text>
          <div>
            <CustomRating
              value={rating}
              readOnly={locked}
              onChange={(val) => {
                if (!locked) {
                  setRating(val);
                  if (val > 0) setRatingError("");
                }
              }}
              size={24}
              spacing={6}
              allowHalfStars={false}
            />
          </div>
          {!locked && ratingError && (
            <Text size="12px" weight="400" color="#D9534F" marginTop="6px">
              {ratingError}
            </Text>
          )}
        </div>
        {locked ? (
          <div className={styles["comment_section"]}>
            <Text size="12px" weight="400" color="#6F7788" marginBottom="5px">
              {t("aiAssistant.feedbackModal.comment")}
            </Text>
            <Text size="14px" weight="600" color="#102C42" overflowWrap>
              {latestResponse?.commentByUser &&
              latestResponse.commentByUser.trim() !== ""
                ? latestResponse.commentByUser
                : "--"}
            </Text>
          </div>
        ) : (
          <>
            <Text size="13px" weight="400" color="#6F7788">
              {t("aiAssistant.feedbackModal.comment")}
            </Text>
            <Input
              Type="text"
              Placeholder={t("Type your message", { field: t("your message") })}
              Name={"MessageToRating"}
              Value={comment}
              MaxLength={500}
              HandleChange={handleChange}
            />
          </>
        )}
      </ModalBody>
      {!locked && (
        <div className={styles["common-appointment-btn-container"]}>
          <Button
            className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
            onClick={handleClick}
          >
            {t("submit")}
          </Button>
          <Button
            className="button button-round button-border button-dark btn-mobile-link"
            onClick={() => setModalOpen(!modalOpen)}
          >
            {t("patientAppointmentMembers.cancel")}
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default CustomFeedbackModal;
